export class UpdateCreditReversalStatusCommand {

    public creditId : number;

    public isReversed : boolean;

}
